document.addEventListener("scroll", (event) => {
  let header = document.querySelector('.yas_header');
  if (!header.classList.contains('stiky-active') && document.querySelector('.yas_header').offsetTop > 30) {
   document.querySelector('.yas_header').classList.toggle('stiky-active');
  }
  if (header.classList.contains('stiky-active') && document.querySelector('.yas_header').offsetTop <= 30) {
   document.querySelector('.yas_header').classList.toggle('stiky-active');
  }
});
document.addEventListener("DOMContentLoaded", (event) => {
  let header = document.querySelector('.yas_header');
  if (!header.classList.contains('stiky-active') && document.querySelector('.yas_header').offsetTop > 30) {
   document.querySelector('.yas_header').classList.toggle('stiky-active');
  }
  if (header.classList.contains('stiky-active') && document.querySelector('.yas_header').offsetTop <= 30) {
   document.querySelector('.yas_header').classList.toggle('stiky-active');
  }

  let swiperReview = document.querySelector('.review_global .mySwiper_review');
  if(swiperReview != null){
    var swiper = new Swiper('.review_global .mySwiper_review', {
      slidesPerView: 1,
      spaceBetween: 30,
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.review_global .swiper-button-next',
        prevEl: '.review_global .swiper-button-prev',
      },
    });
  }


  const filterBlock = document.querySelector('.filter_btnside .mc-link');

  if (filterBlock) {
    const links = filterBlock.querySelectorAll('a');
  
    links.forEach(link => {
      link.addEventListener('click', function (e) {
         if (link.target === '_blank') return;
         
          e.preventDefault();

          document.documentElement.classList.remove('is-loaded');
          window.location.href = link.href;
      });
    });
  }

  
  let swiperProduct = document.querySelector('.mySwiper_product_img');
  if(swiperProduct != null){
    var swiper = new Swiper(".mySwiper_product_img", {
      slidesPerView: 1,
        spaceBetween: 10,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".mySwiper_product_img .swiper-button-next",
          prevEl: ".mySwiper_product_img .swiper-button-prev",
        },
        breakpoints: {
          // when window width is <= 576px (mobile)
          469: {
            slidesPerView: 1.5,
            spaceBetween: 10
          },
          659: {
            slidesPerView: 2.5,
            spaceBetween: 10
          },
          // when window width is <= 992px (tablet)
          992: {
            slidesPerView: 3.5,
            spaceBetween: 10
          },
          // when window width is > 992px (desktop)
          1200: {
            slidesPerView: 3.5,
            spaceBetween: 10
          }
        }
      });
  }


  let midSwipermob = document.querySelector('.midSwipermob');
  if(midSwipermob != null){
      var swiper = new Swiper(".firstwipemob", {
        freeMode: true,
        loop: true,
        //rtl: true,  // Enable right-to-left mode
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
        },
        slidesPerView: 2.5,
        spaceBetween: 10,
        speed: 2500,
        pagination: {
          el: ".firstwipemob .swiper-pagination",
          clickable: true,
        },
        breakpoints: {
          640: {
            slidesPerView: 3.5,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 15,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 15,
          },
        },
      });
      var swiper = new Swiper(".midSwipermob", {
       freeMode: true,
        loop: true,
        autoplay: {
        delay: 0,
        disableOnInteraction: false,
        },
        slidesPerView: 2.5,
        spaceBetween: 10,
        speed: 3000,
        pagination: {
          el: ".midSwipermob .swiper-pagination",
          clickable: true,
        },
      });
  }
  let firstwipe = document.querySelector('.firstwipe');
  if(firstwipe != null){
    function initializeSwiper(selector, speed, direction, revers) {
      new Swiper(selector, {
          direction: direction,
          freeMode: true,
          a11y: false,
          loop: true,
          slidesPerView: "auto",
          spaceBetween: 15,
          autoHeight: true,
          grabCursor: true,
          loopAdditionalSlides: 2,
          loopAddBlankSlides: true,
          autoplay: {
             delay: 0,
             disableOnInteraction: false,
             reverseDirection: revers,
          },
          breakpoints: {
              768: {
                  spaceBetween: 15,
              },
              1024: {
                  spaceBetween: 15,
              },
          },
          speed: speed,
  
      });
  }

  // Initialize Swipers
  initializeSwiper(".firstwipe", 4000, "vertical", false);
  initializeSwiper(".midSwiper", 3000, "vertical", true);
  initializeSwiper(".rightswipe", 5000, "vertical", false);
  }

  let slider_section_yas = document.querySelector('.slider_section-yas');
    if(slider_section_yas != null){
      var swiper = new Swiper(".slider_section-yas .swiper_slider", {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: false,
        breakpoints: {
          640: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          1024: {
            slidesPerView: 3.5,
            spaceBetween: 10,
          },
        },
      });
  }

  let mobile_slider_section_yas = document.querySelector('.mobile_slider_section-yas');
    if(mobile_slider_section_yas != null){
      var swiper = new Swiper(".mobile_slider_section-yas .mobile_slider", {
        slidesPerView: 1.5,
        centeredSlides: true,
        spaceBetween: 20,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: false,
        
      });
  }

  
  let badges_mobile = document.querySelector('.badges_mobile');
    if(badges_mobile != null){
    var swiper = new Swiper(".badges_mobile", {
       freeMode: true,
        loop: true,
        autoplay: {
        delay: 0,
        freeMode: true,
        disableOnInteraction: false,
        },
        slidesPerView: 2,
        spaceBetween: 0,
        speed: 5000,
        pagination: false,
    });
  }


  let secrch_banner_yas = document.querySelector('#secrch_banner_yas');

  if(secrch_banner_yas != null){
    const searchInput = document.getElementById('secrch_banner_yas');
    const originalPlaceholder = searchInput.getAttribute('placeholder');
    const collectionList = document.querySelector('.search_banner .collection-list');
    const searchForm = document.querySelector('.banner_search_form');
    
    function hideCollectionList() {
      collectionList.style.display = 'none';
    }
    
    function showCollectionList() {
      collectionList.style.display = 'block';
    }
    
    function resetInputToPlaceholder() {
      searchInput.value = '';
      searchInput.setAttribute('placeholder', originalPlaceholder);
    }
    
    searchInput.addEventListener('click', function(event) {
      event.stopPropagation();
      showCollectionList();
    });
    
    document.body.addEventListener('click', function(event) {
      if (
        !event.target.closest('.search-form') &&
        !event.target.closest('.collection-list') 
      ) {
   
        hideCollectionList();
       // resetInputToPlaceholder();
      }
    });
    
    searchInput.addEventListener('input', function() {
      const query = searchInput.value.toLowerCase();
      const listItems = collectionList.querySelectorAll('li');
    
      listItems.forEach(function(item) {
        const collectionTitle = item.textContent.toLowerCase();
        if (collectionTitle.includes(query)) {
          item.style.display = '';
        } else {
          item.style.display = 'none';
        }
      });
    });
    
    searchForm.addEventListener('submit', function(event) {
      event.preventDefault();
      var firstVisibleLi = Array.from(
        document.querySelectorAll('.search_banner .collection-list li')
      ).find(el => getComputedStyle(el).display !== 'none');
      
      if (firstVisibleLi) {
        var link = firstVisibleLi.querySelector('a');
        if (link) {
          link.click();
        }
      }
    });
  }


  if (!document.getElementById('calendly-widget-script')) {
          // Load Calendly stylesheet
          var link = document.createElement('link');
          link.rel = 'stylesheet';
          link.href = 'https://assets.calendly.com/assets/external/widget.css';
          document.head.appendChild(link);
    
          // Load Calendly script
          var script = document.createElement('script');
          script.src = 'https://assets.calendly.com/assets/external/widget.js';
          script.id = 'calendly-widget-script';
          script.async = true;
          document.body.appendChild(script);
  }

  
});
